<template>
	<div style="padding: 10px;">
		<el-row :gutter="20">
			<el-col :span="5"> 
				<el-cascader style="width: 100%;" v-model="searchInfo.orgs" :options="allOrgTree" :props="orgtreePro"  clearable></el-cascader>
			</el-col>
			<el-col :span="5">
				<el-input clearable placeholder="按名称查询" v-model="searchInfo.name">
					<template slot="prepend">位置名称</template>
				</el-input>
			</el-col>
			<el-col :span="14"> 
				<div style="min-width: 350px;">
					<el-button type="primary" @click="searchSysUser" icon="el-icon-search">搜索</el-button>
					<el-button  icon="el-icon-refresh" @click="clearSearch">重置</el-button>
					<el-button type="primary" icon="el-icon-plus" @click="addLoc">新增</el-button>
					<el-button type="primary" @click="importShow = true" icon="el-icon-upload">导入房间和设备点位</el-button>
					<el-button type="danger" icon="el-icon-delete" @click="deleteBySchool">删除</el-button>
				</div>
			</el-col>
		</el-row>
		<div style="margin-top: 10px;">
			<el-table :data="sysLocsList" v-loading="loading" style="width: 100%"  max-height="700" @selection-change="handleSelectionChange">
				<el-table-column type="selection" align="center" width="55"> </el-table-column>
			    <el-table-column fixed="left" prop="name" label="名称" width="150" align="center"></el-table-column>
				<el-table-column prop="orgid" label="所属组织" align="center"></el-table-column>
			    <el-table-column prop="typename" label="类型" align="center"></el-table-column>
				<el-table-column prop="idx" label="排序" align="center"></el-table-column>
				<el-table-column fixed="right" prop="op" label="操作" width="280" align="center">
					<template slot-scope="scope">
						<a @click="goSysLocDetail(scope.$index, scope.row)" title="详情" style="display:inline-block;cursor:pointer;color: #409EFF;">
							<i class="el-icon-Stall">详情</i>
						</a>
						<a @click="goLocPointDetail(scope.$index, scope.row)" title="点位" style="display:inline-block;cursor:pointer;color: #67C23A;margin-left: 20px;">
							<i class="el-icon-Stall">点位</i>
						</a>
						<a @click="goLocDevDetail(scope.$index, scope.row)" title="设备" style="display:inline-block;cursor:pointer;color: #67C23A;margin-left: 20px;">
							<i class="el-icon-Stall">设备</i>
						</a>
						<a @click="noUseDetail(scope.$index, scope.row)" title="删除" style="display:inline-block;cursor:pointer;color: #F56C6C;margin-left: 20px;">
							<i class="el-icon-Stall">删除</i>
						</a>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<div style="text-align: center;">
			<el-pagination background layout="total, prev, pager, next, sizes" :page-sizes="[10, 20, 50]" :current-page="param.page"
				:page-size="param.pagenum" :total="locTotal" @size-change="handleSizeChange" @current-change="handleCurrentChange"> </el-pagination>
		</div>
		<el-dialog @close="refrashData" :destroy-on-close="true" :title="detailTitle" width="70%" :visible.sync="detailShow">
			<LocDetail @needRefrash="needRefrash" :add="isadd" :allOrgTree="allOrgTree" :selectedloc="selectset"></LocDetail>
		</el-dialog>
		<el-dialog :destroy-on-close="true" title="位置关联的点位" width="70%" :visible.sync="detailPointShow">
			<LocPoint :selectedloc="selectset"></LocPoint>
		</el-dialog>
		<el-dialog @close="refrashData" :destroy-on-close="true" title="导入房间和设备点位" width="70%" :visible.sync="importShow">
			<ImportRoom :allOrgTree="allOrgTree"></ImportRoom>
		</el-dialog>
		<el-dialog :destroy-on-close="true" title="位置关联的设备" width="70%" :visible.sync="detailDevShow">
			<LocDev :selectedloc="selectset"></LocDev>
		</el-dialog>
	</div>
</template>

<script>
	//import dayjs from 'dayjs'
	import { querySysLocs, queryAllOrgTree, deleteSysLocation, 
		deleteSysLocationMutil } from '/static/apiUrl.js'
	import LocDetail from './locdetail'
	import LocPoint from './locpoint'
	import ImportRoom from './importroom.vue'
	import LocDev from './locdev.vue'
	export default {
		name : 'SysUser',
		data() {
			return {
				loading : false,
				detailShow: false,
				detailDevShow : false,
				detailPointShow : false,
				importShow : false,
				editok : false,
				isadd : false,
				detailTitle: '位置详情',
				selectset: null,	
				searchInfo:{
					name: '',
					orgs : '',
				},
				allOrgTree : [],
				param : {
					page : 1,
					pagenum : 10,
				},
				locTotal : 0,
				sysLocsList : [],
				orgtreePro : {
					checkStrictly: true,
					value : "id",
					label : "name",
					children : "children"
				},
				selectids : [],
				
			}
		},
		mounted() {
			this.initData()
			this.queryLocList()
		},
		components: {
			LocDetail,
			LocPoint,
			ImportRoom,
			LocDev,
		},
		methods: {
			handleSizeChange(val){
				this.param.pagenum = val;
				this.queryLocList()
			},
			handleCurrentChange(val){
				this.param.page = val
				this.queryLocList()
			},
			initData() {
				this.allOrgTree = []
				queryAllOrgTree().then(res => {
					if(0 == res.code){
						this.allOrgTree = res.datas
					}
				})
			},
			searchSysUser(){
				this.param.page = 1
				this.sysLocsList = []
				this.queryLocList()
			},
			clearSearch(){
				this.searchInfo.name = ''
				this.searchInfo.orgs = ''
				this.param.page = 1
				this.queryLocList()
			},
			queryLocList(){
				this.loading = true
				this.sysLocsList = []
				let orgid = ""
				if(this.searchInfo.orgs.length > 0){
					orgid = this.searchInfo.orgs[this.searchInfo.orgs.length -1]
				}
				querySysLocs({
					oid : orgid,
					name : this.searchInfo.name,
					pagenum : this.param.page ,
					pagesize : this.param.pagenum
				}).then(res => {
					this.loading = false
					if(0 == res.code){
						this.locTotal = res.datas.totalnum
						res.datas.data.forEach((set) => {
							this.sysLocsList.push(set)
						})
					}else{
						this.locTotal = 0
					}
				})
			},
			goSysLocDetail(idx,row){
				this.detailTitle = '位置详情'
				this.isadd = false
				this.selectset = JSON.parse(JSON.stringify(this.sysLocsList[idx]))
				this.detailShow = true
			},
			goLocPointDetail(idx,row){
				this.selectset = JSON.parse(JSON.stringify(this.sysLocsList[idx]))
				this.detailPointShow = true
			},
			goLocDevDetail(idx,row){
				this.selectset = JSON.parse(JSON.stringify(this.sysLocsList[idx]))
				this.detailDevShow = true
			},
			noUseDetail(idx,row){
				this.$confirm('此操作将删除位置 '+this.sysLocsList[idx].name+', 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					deleteSysLocation({
						id : this.sysLocsList[idx].id
					}).then(res => {
						if(0 == res.code){
							this.queryLocList()
							this.$message({
								showClose: true,
								message: "删除成功",
								type: 'success'
							});
						}else{
							this.$message({
								showClose: true,
								message: res.message,
								type: 'error'
							});
						}
					})
				}).catch(() => {
					console.log("取消")
				});
			},
			addLoc(){
				this.detailTitle = "新增位置"
				this.isadd = true
				this.selectset = null
				this.detailShow = true
			},
			needRefrash(val,isshow){
				this.editok = val
				this.detailShow = isshow
			},
			refrashData() {
				if(this.editok){
					this.queryLocList()
				}
			},
			handleSelectionChange(val){
				this.selectids = [];
				if(val.length > 0){
					val.forEach((item) => {
						this.selectids.push(item.id)
					})
				}
			},
			deleteBySchool(){
				if(this.selectids.length == 0){
					this.$message({
						showClose: true,
						message: '请选择需要删除的位置。',
						type: 'warning'
					});
					return
				}
				this.$confirm('确定删除选中的位置吗?删除位置会一并删除位置和点位的关联', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					const loading = this.$loading({
						lock: true,
						text: '删除数据中...',
						spinner: 'el-icon-loading',
						background: 'rgba(0, 0, 0, 0.7)'
					});
					deleteSysLocationMutil(this.selectids).then(res => {
						if(0 == res.code){
							this.queryLocList()
							this.$message({
								showClose: true,
								message: "删除成功",
								type: 'success'
							});
						}else{
							this.$message({
								showClose: true,
								message: res.message,
								type: 'error'
							});
						}
						loading.close();
					})
				}).catch(() => {
					console.log("取消")
				})
			},
			
		},
		beforeDestroy() {
			
		},
	}
</script>

<style scoped>
	
</style>